import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

Injectable()
export class AuthInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(this.token(req)).catch((error, caught) => {
    
          if (error instanceof HttpErrorResponse) {
    
              switch ((<HttpErrorResponse>error).status) {
                  case 401:
                    localStorage.clear();
                    window.location.reload();
                    return caught;
              }
    
          } else {
            return Observable.throw(error);
          }
    
        }) as any;
    }

    token(req) {
        const idToken = localStorage.getItem("token");

        if (idToken) {
            const cloned = req.clone({
				headers: req.headers.set("Authorization","Bearer " + idToken)
				// .set("Content-Type", "application/json")
            });

            return cloned;
        }

        return req;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/Auth.interceptor.ts